export const ROUTES = {
  // 认证
  LOGIN: '/admin/login',
  
  // 仪表盘
  DASHBOARD: '/admin',
  
  // 系统管理
  USERS: '/admin/users',
  ROLES: '/admin/roles',
  PERMISSIONS: '/admin/permissions',
  AUDIT_LOGS: '/admin/audit-logs',
  ANALYTICS: '/admin/analytics',
  DATA_ANALYTICS: '/admin/data-analytics',
  
  // 内容管理
  BANNERS: '/admin/banners',
  NEWS: '/admin/news',
  PARTNERS: '/admin/partners',
  JOBS: '/admin/jobs',
  FEEDBACK: '/admin/feedback',
  
  // 投资者关系
  FINANCIAL_REPORTS: '/admin/financial-reports',
  GOVERNANCE: '/admin/governance',
  ANNOUNCEMENTS: '/admin/announcements',
  
  // 关于我们
  MILESTONES: '/admin/milestones',
  HONORS: '/admin/honors',
  ORG_STRUCTURE: '/admin/org-structure',
} as const;
